// extracted by mini-css-extract-plugin
export default {"header":"dgVpv","mobile":"RriCw","desktop":"_2gSic","hidden":"YURGo"};